import instance from "../utils/network";

export enum PubMissionType {
  MISSION = "mission",
  BINGO = "bingo",
}

export enum PubMissionLogType {
  PROGRESS_INCREASE = "PROGRESS_INCREASE",
  PROGRESS_DECREASE = "PROGRESS_DECREASE",
  COMPLETE = "COMPLETE",
  CANCEL_COMPLETE = "CANCEL_COMPLETE",
  BINGO_LINE_ACHIEVE = "BINGO_LINE_ACHIEVE",
  CANCEL_BINGO_LINE_ACHIEVE = "CANCEL_BINGO_LINE_ACHIEVE",
  OTHER_REWARD_GRANT = "OTHER_REWARD_GRANT",
  CANCEL_OTHER_REWARD_GRANT = "CANCEL_OTHER_REWARD_GRANT",
  STORE_VOUCHER_GRANT = "STORE_VOUCHER_GRANT",
  CANCEL_STORE_VOUCHER_GRANT = "CANCEL_STORE_VOUCHER_GRANT",
  DELETE = "DELETE",
}

export enum SellerPubMissionLogCategoryFilter {
  ALL = "ALL",
  MISSION = "MISSION",
  BINGO = "BINGO",
}

export enum SellerPubMissionLogTypeFilter {
  ALL = "ALL",
  PROGRESS_INCREASE = "PROGRESS_INCREASE",
  PROGRESS_DECREASE = "PROGRESS_DECREASE",
  COMPLETE = "COMPLETE",
  CANCEL_COMPLETE = "CANCEL_COMPLETE",
  BINGO_LINE_ACHIEVE = "BINGO_LINE_ACHIEVE",
  CANCEL_BINGO_LINE_ACHIEVE = "CANCEL_BINGO_LINE_ACHIEVE",
  OTHER_REWARD_GRANT = "OTHER_REWARD_GRANT",
  CANCEL_OTHER_REWARD_GRANT = "CANCEL_OTHER_REWARD_GRANT",
  STORE_VOUCHER_GRANT = "STORE_VOUCHER_GRANT",
  CANCEL_STORE_VOUCHER_GRANT = "CANCEL_STORE_VOUCHER_GRANT",
  DELETE = "DELETE",
}

export interface SellerPubMissionLogListRequest {
  pubId: number;
  page: number;
  limit: number;
  /** YYYY-MM-DD */
  startDate?: string;
  /** YYYY-MM-DD */
  endDate?: string;
  nickname?: string;
  category?: SellerPubMissionLogCategoryFilter;
  logType?: SellerPubMissionLogTypeFilter;
  processorNickname?: string;
}

export interface SellerPubMissionLogItemResponse {
  id: number;
  /** YYYY-MM-DD HH:mm */
  createdAt: string;
  nickname: string;
  missionName: string;
  missionId: number;
  type: PubMissionType;
  typeLabel: string;
  logType: PubMissionLogType;
  logTypeLabel: string;
  value: string | null;
  memo: string | null;
  processorNickname: string | null;
}

export interface SellerPubMissionLogListResponse {
  total: number;
  list: SellerPubMissionLogItemResponse[];
}

export function getPubMissionLogList(
  request: SellerPubMissionLogListRequest,
): Promise<SellerPubMissionLogListResponse> {
  return instance.get("/seller/pub-mission-log", { params: request });
}
